export const BUYER_REQUESTED_COUNT = 'buyer_requested_count';

export const SINGLE_VALUE = 'one';
export const MULTIPLE_VALUE = 'other';
